import {
  ADD_USER_DATA,
  RESET_LOCAL_STATE,
  RESTORE_LOCAL_STATE,
  SET_SECONDARY_MARKET_DATA,
  SET_ASSET_DETAILS,
  UPDATE_ON_CANCEL_ORDER,
  SET_ASSETS_ASSET_DETAILS,
} from "./actionTypes";
import SecondaryMarketService from "@services/SecondaryMarket.service";
import { EordersTypes } from "@market/enums/OrdersTypes";
import BttfAxios from "@features/utils/axios";
import { catchError, hasRequiredTier } from "@features/utils/functions";
import { IWalletDetails } from "@market/interfaces/IWallet";
import { MAIN_CURRENCY } from "@bundles/consts";
import { ETiers } from "@appComponents/components/IdentityStatusLabel/IIdentityStatusLabel";

export const resetStore = () => {
  return {
    type: RESET_LOCAL_STATE,
  };
};

export const restoreStore = () => {
  return {
    type: RESTORE_LOCAL_STATE,
  };
};

export const setUserData = (): any => {
  return (dispatch: any): any => {
    return BttfAxios.get(`/api/users/me`, (res) => {
      const certificationStatus = res.data.certification_status;

      const data = {
        id: res.data.investor_id,
        is_verified: hasRequiredTier(ETiers.tier_0_kyc, res.data.tier),
        is_certified: res.data.is_certified,
        is_certified_or_selfcertified:
          ["certified", "self_certified"].indexOf(certificationStatus) > -1,
        verification_status: res.data.verification_status,
        certification_status: certificationStatus,
        us_resident: res.data.us_resident,
        slug: res.data.nickname,
        _2fa_enabled: res.data["2fa_enabled"],
      };

      dispatch({
        type: ADD_USER_DATA,
        payload: data,
      });

      return data.id;
    });
  };
};

export const setSecondaryMarketData =
  (investorId?: number): any =>
  (dispatch: Function) => {
    Promise.all([
      SecondaryMarketService.getSPVs(),
      investorId ? SecondaryMarketService.getApiSettings() : null,
      investorId ? SecondaryMarketService.getWallets(investorId) : null,
    ])
      .then((res) => {
        if (res[1]) {
          res[1].data = res[1].data.share_service;
        }

        if (res[2]) {
          res[2].data = {
            bftWallet: res[2].data.find(
              (wallet: IWalletDetails) => wallet.currency === "bft"
            ),
            usdWallet: res[2].data.find(
              (wallet: IWalletDetails) => wallet.currency === MAIN_CURRENCY
            ),
          };
        }

        dispatch({
          type: SET_SECONDARY_MARKET_DATA,
          payload: res,
        });
      })
      .catch((err) => {
        catchError(err, true);
      });
  };

export const setAssetDetails =
  (assetId: number, spvId: number) => (dispatch: Function) => {
    return Promise.all([
      SecondaryMarketService.getAssetOrders(assetId),
      SecondaryMarketService.getSPV(spvId),
      SecondaryMarketService.getSPVInvestorDetails(spvId),
    ])
      .then((res) => {
        dispatch({
          type: SET_ASSET_DETAILS,
          payload: { assetId, res },
        });
      })
      .catch((err) => {
        catchError(err, "/market/");
      });
  };

export const setAssetsAssetDetails =
  (spvId: number, assetId: number, investorId: number) =>
  (dispatch: Function) => {
    return Promise.all([
      SecondaryMarketService.getSPVs(),
      SecondaryMarketService.getAssetOrders(assetId),
      SecondaryMarketService.getSPV(spvId),
      SecondaryMarketService.getSPVInvestorDetails(spvId),
      SecondaryMarketService.getTradesHistory(assetId),
      SecondaryMarketService.getApiSettings(),
      SecondaryMarketService.getWallets(investorId),
    ])
      .then((res) => {
        res[5].data = res[5].data.share_service;
        res[6].data = {
          bftWallet: res[6].data.find(
            (wallet: IWalletDetails) => wallet.currency === "bft"
          ),
          usdWallet: res[6].data.find(
            (wallet: IWalletDetails) => wallet.currency === MAIN_CURRENCY
          ),
        };

        dispatch({
          type: SET_ASSETS_ASSET_DETAILS,
          payload: { assetId, res },
        });
      })
      .catch((err) => {
        catchError(err, "/market/");
      });
  };

export const updateStoreOnCancelOrder = (
  numberOfAvailableShares: number,
  orderId: number,
  assetId: number,
  orderType: EordersTypes
) => {
  return {
    type: UPDATE_ON_CANCEL_ORDER,
    payload: { numberOfAvailableShares, orderId, assetId, orderType },
  };
};
